export default __webpack_public_path__ + "static/media/cases5.e032dfbc.webp";